/**
 * Check if URL looks like it has already been cached.
 */
export function isCachedUrl(url: string): boolean {
    const liveProtocols = ['http:', 'https:', '//', '/'];
    const foundLiveProtocol = liveProtocols.find((protocol) => url.startsWith(protocol));
    return !foundLiveProtocol;
}

export const IMAGE_ASSET_CACHE_IGNORE_CSS_CLASS = 'image-cache-ignore';

/**
 * Determines whether an element's image should not be cached by checking
 * both it and its parent elements
 */
export function shouldBeIgnored(target: Element): boolean {
    return (
        target.matches(`.${IMAGE_ASSET_CACHE_IGNORE_CSS_CLASS}`) ||
        Boolean(target.closest(`.${IMAGE_ASSET_CACHE_IGNORE_CSS_CLASS}`))
    );
}
